import React from 'react';

const Logo = React.memo(({ size = "normal", className = "" }) => (
  <div className={`flex items-center ${className}`}>
    <img 
      src="/logo.png" 
      alt="Ceballos Total Framing LLC Logo"
      className={`${size === 'large' ? 'h-16' : 'h-12'} w-auto`}
    />
  </div>
));

export default Logo;